var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14804_79768)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.12695 0H85.873V45H-4.12695V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.12695 29.9971H85.873V45H-4.12695V29.9971Z",
    fill: "#D50000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4.12695 15.0029H85.873V29.9971H-4.12695V15.0029Z",
    fill: "#0000BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3965 8.17383C21.0449 13.5879 20.834 16.5586 20.0166 17.9297C19.1201 19.4062 18.2588 20.4873 14.7695 21.7969C11.2891 20.4873 10.4277 19.4062 9.53125 17.9297C8.70508 16.5586 8.50293 13.5879 8.15137 8.17383L8.66113 7.99805C9.69824 7.68164 10.4717 7.42676 11.043 7.3125C11.8604 7.13672 12.5635 6.94336 14.7607 6.89941C16.958 6.93457 17.6611 7.14551 18.4785 7.32129C19.041 7.44434 19.8496 7.67285 20.8779 7.99805L21.3965 8.17383Z",
    fill: "#D50000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8867 7.99805C20.5527 13.4033 20.2715 15.8818 19.832 17.0684C18.9883 19.1074 17.6523 20.2236 14.7695 21.2871C11.8867 20.2236 10.5508 19.1074 9.69824 17.0684C9.25879 15.873 8.99512 13.4033 8.66113 7.98926C9.68066 7.67285 10.4717 7.42676 11.043 7.3125C11.8604 7.13672 12.5635 6.93457 14.7607 6.89941C16.958 6.93457 17.6611 7.13672 18.4785 7.3125C19.2921 7.4977 20.0958 7.72357 20.8867 7.98926V7.99805Z",
    fill: "#0000BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7695 9.65039L14.9014 9.97559L15.5166 10.0635L15.1211 10.3008L15.499 10.5557L14.9453 10.6436L14.7695 10.9424L14.5937 10.6348L14.0664 10.5645L14.418 10.3008L14.0488 10.0635L14.6377 9.97559L14.7695 9.65039Z",
    fill: "#FFDF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6299 15.7852L19.2871 15.5215L19.0498 15.1172L18.5752 14.7041L18.3203 14.291L17.8457 13.8604L17.6172 13.4473L17.3535 13.2451L17.1953 13.0781L16.7559 13.4561L16.5273 13.8691L16.2373 14.1328L15.9121 13.8779L15.6748 13.4561L14.7695 11.8477L13.8643 13.4561L13.627 13.8779L13.3018 14.1328L13.0117 13.8691L12.7744 13.4561L12.3438 13.0781L12.1768 13.2363L11.9219 13.4473L11.6934 13.8604L11.2188 14.291L10.9639 14.7041L10.4893 15.1172L10.252 15.5215L9.90918 15.7852C10.1024 16.9949 10.6748 18.1121 11.5439 18.9756C12.4868 19.7825 13.5801 20.3949 14.7607 20.7773C15.9504 20.4034 17.051 19.7903 17.9951 18.9756C18.5049 18.4482 19.4541 17.2793 19.6299 15.7852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2109 7.37402L16.3516 7.69922L16.9668 7.78711L16.5625 8.02441L16.9492 8.2793L16.3955 8.36719L16.2197 8.66602L16.0439 8.3584L15.5166 8.28809L15.8682 8.02441L15.499 7.78711L16.0791 7.69922L16.2197 7.37402H16.2109ZM13.3105 7.37402L13.4512 7.69922L14.0664 7.77832L13.6709 8.01562L14.0488 8.27051L13.4951 8.3584L13.3193 8.65723L13.1436 8.3584L12.6162 8.2793L12.9678 8.01562L12.5986 7.77832L13.1875 7.69043L13.3193 7.36523L13.3105 7.37402Z",
    fill: "#FFDF00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.874 17.8418H18.2236L17.6084 17.7979L16.8789 17.4463H16.0527L15.3408 17.7979L14.7695 17.8506L14.207 17.7979L13.4951 17.4463H12.6602L11.9219 17.7979L11.3154 17.8506L10.6475 17.8418L10.3311 17.2969L10.3398 17.2793L11.3242 17.4463L11.9307 17.4023L12.6602 17.042H13.4863L14.207 17.3936L14.7695 17.4463L15.3408 17.3936L16.0527 17.042H16.8789L17.6172 17.3936L18.2236 17.4463L19.1729 17.2705L19.1904 17.3057L18.8652 17.8418H18.874ZM11.2803 18.6768L11.9307 18.6328L12.6602 18.2813H13.4863L14.207 18.6328L14.7695 18.6768L15.332 18.6328L16.0527 18.2813H16.8789L17.6084 18.6328L18.2676 18.6768L18.6895 18.1494H18.6807L18.2236 18.2725L17.6172 18.2285L16.8877 17.877H16.0615L15.3408 18.2285L14.7783 18.2813L14.207 18.2285L13.4951 17.877H12.6602L11.9219 18.2285L11.3154 18.2813L10.876 18.167V18.1846L11.2715 18.6768H11.2803Z",
    fill: "#0000BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14804_79768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSl);
export default __webpack_public_path__ + "static/media/sl.66bab0db6611ac2c08e8c1885e2a60da.svg";
export { ForwardRef as ReactComponent };